/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedLetterP = createReactComponent(
  "square-rounded-letter-p",
  "IconSquareRoundedLetterP",
  [
    ["path", { d: "M10 12h2a2 2 0 1 0 0 -4h-2v8", key: "svg-0" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-1"
      }
    ]
  ]
);

export { IconSquareRoundedLetterP as default };
//# sourceMappingURL=IconSquareRoundedLetterP.js.map
